import { useState } from 'react'
import CardLayout from '../../../components/utils/CardLayout'
import RepushActivation from './RepushActivation';
import PrepaidIQActivation from './PrepaidIQActivation'
import PortinActivation from './PortinActivation'

const RepushctivationRequest = () => {
    const [activeTab, setActiveTab] = useState('Automation Activation');

    const handleTabClick = (tab) => {
        setActiveTab(tab);
    };

    const repushActivationPage = () => {
        return <RepushActivation />;
    }

    const prepaidActivationPage = () => {
        return <PrepaidIQActivation />;
    }

    const portinActivationPage = () => {
        return <PortinActivation />;
    }

    return (
        <CardLayout title={activeTab}>
            <>
                <ul className="nav nav-tabs plan-tab" id="myTab" role="tablist" style={{ display: 'flex', gap: '2px' }}>
                    <li className="nav-item" role="presentation">
                        <button className={`nav-link ${activeTab === 'Automation Activation' ? 'active' : ''}`} onClick={() => handleTabClick('Automation Activation')} >
                            Automation Activation
                        </button>
                    </li>

                    <li className="nav-item" role="presentation">
                        <button className={`nav-link ${activeTab === 'PrepaidIQ Activation' ? 'active' : ''}`} onClick={() => handleTabClick('PrepaidIQ Activation')} >
                            PrepaidIQ Activation
                        </button>
                    </li>
                    <li className="nav-item" role="presentation">
                        <button className={`nav-link ${activeTab === 'Portin Activation' ? 'active' : ''}`} onClick={() => handleTabClick('Portin Activation')} >
                            Portin Activation
                        </button>
                    </li>
                </ul>

                {activeTab == 'Automation Activation' && repushActivationPage()}
                {activeTab == 'PrepaidIQ Activation' && prepaidActivationPage()}
                {activeTab == 'Portin Activation' && portinActivationPage()}
            </>
        </CardLayout>
    )
}

export default RepushctivationRequest